/**
 * Shelter Challenge countdown: reveal the final-day timer once the DOM is ready.
 * Moved out of snippets/cusa-shelter-challenge-countdown-timer.liquid (inline).
 */
document.addEventListener('DOMContentLoaded', function () {
	document.querySelector('.contest-msg.hidden').classList.remove('hidden');
	document.querySelector('#time-left-inner-wrapper.hidden').classList.remove('hidden');
});
